type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "default" | "inverse";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "default",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const isInverse = tone === "inverse";

  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && (
        <p
          className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium tracking-wide ${
            isInverse
              ? "bg-background-50/15 text-accent-300"
              : "bg-primary-100 text-primary-700"
          }`}
        >
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-line" aria-hidden="true"></i>
          </span>
          {eyebrow}
        </p>
      )}
      <h2
        className={`mt-4 font-heading text-2xl font-bold leading-tight tracking-tight md:text-4xl ${
          isInverse ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            isInverse ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}